import { configRefs } from '@utils/constants';
import { FORMAT_SIZE_IN_MM } from '../constants.js';
import { printerSelectors } from '../selectors.js';

/**
 * inserts a global stylesheet that ensures all other content than the
 * printManager node is hidden on print.
 */
function setupPrintStylesheet(format, displayPreparedInputOnScreen) {
  const styleSheet = document.querySelector("style[data-printer-stylesheet='true']") ?? document.createElement("style");
  styleSheet.replaceChildren();
  if (!format) {
    return;
  }
  const formatDimensions = FORMAT_SIZE_IN_MM[format];
  styleSheet.dataset["printerStylesheet"] = "true";
  styleSheet.type = "text/css";
  if (!displayPreparedInputOnScreen || configRefs.env.node.dangerouslyAssertSyncValue() === "production") {
    styleSheet.appendChild(document.createTextNode(`@media not print {
      ${printerSelectors.container()} {
        position: fixed;
        top: 0;
        left: -10000px;

        opacity: 0;
        pointer-events: none;
      }
    }`.trim()));
  }
  styleSheet.appendChild(document.createTextNode(`
    @media print {
      body {
        -webkit-print-color-adjust: exact !important;
      }

      body > *:not(${printerSelectors.container()}) {
        display: none !important;
      }

      *:has( ${printerSelectors.container()}) {
        display: contents !important;
      }

      @page {
        margin: 0;
        size: ${formatDimensions.width}mm ${formatDimensions.height}mm;
      }
    }
`.trim()));
  document.body.appendChild(styleSheet);
}

export { setupPrintStylesheet };
//# sourceMappingURL=util.setup-stylesheet.js.map
